module.exports = __webpack_public_path__ + "img/ways.bc898da3.png";